module.exports = __webpack_public_path__ + "static/media/ai-background.6f3b68b0.png";